import styled from 'styled-components';

export const Container = styled.div`
  background-color: rgb(250, 250, 250);
  flex-flow: row wrap;
  flex: none;
  align-self: stretch;
  display: flex;
  padding-top:10px;
  
  > div {
    margin: 0;
    height: 100%;
  }
`;

export const InputContainer = styled.div`
  color: rgb(51, 51, 51);
  width: 100%;
  display: flex;
  align-items: center;
  background-color: rgb(250, 250, 250);
  border: 3px solid transparent;
  box-sizing: border-box;

  &:hover {
    background-color: #f1f1f1;
  }

  &:focus-within,
  &:active {
    color: rgb(51, 51, 51);
    background-color: rgba(0, 0, 0, 0.1);
    box-shadow: rgb(34, 81, 255) 4px 0px 0px 0px inset;
    border-top: 3px solid black;
    border-right: 3px solid black;
    border-bottom: 3px solid black;
    border-left: none;
    font-family: 'McKinsey Sans Regular', Helvetica Neue, Calibri, sans-serif !important;

    .span {
      font-family: 'McKinsey Sans Regular', Helvetica Neue, Calibri, sans-serif !important;
    }
  }
  .span {
    font-family: 'McKinsey Sans Light';
    color: rgb(51, 51, 51) !important;
    text-decoration: none;
    line-height: 1.5;
    font-size: 1rem;
    font-weight: 300;
  }
  .span:active,
  .span:focus {
    font-family: 'McKinsey Sans Regular', Helvetica Neue, Calibri, sans-serif !important;
  }
`;

export const Anchor = styled.a`
  display: flex;
  justify-content: left;
  align-items: center;
  min-height: 25px;
  padding: 8px 12px;
  margin-right: 10px;
  border: none;
  background-color: transparent;
  width: calc(100% - 40px);
  cursor: default;
  text-decoration: none;
`;

export const Button = styled.button`
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 8px 12px;
  background-color: white;
  color: white;
  border: none;
  background-color: transparent;
  cursor: pointer;
  height: 100%;
`;

export const ArrowIcon = styled.img`
  width: 12px;
  height: 12px;
`;

export const ChildrenContainer = styled.div`
  width: 100%;
  background-color: rgb(250, 250, 250);
  padding-left: calc(1rem);
  line-height: 1.5;
  font-weight: 300;
  font-size: 1rem;
`;
